<div *ngIf="tipo=='dados-registro'">
  <div class="body">
    <label>Nome</label>
    <p>{{dados.Nome[0]}}</p>
    <label>Código MEC</label>
    <p>{{dados.CodigoMEC[0]}}</p>
    <label>CNPJ</label>
    <p>{{dados.CNPJ[0]}}</p>
    <h5>Endereço do Curso</h5>
    <label *ngIf="dados.Endereco[0].Logradouro != undefined">Logradouro</label>
    <p *ngIf="dados.Endereco[0].Logradouro != undefined">{{dados.Endereco[0].Logradouro[0]}}</p>
    <label *ngIf="dados.Endereco[0].Numero != undefined">Número</label>
    <p *ngIf="dados.Endereco[0].Numero != undefined">{{dados.Endereco[0].Numero[0]}}</p>
    <label *ngIf="dados.Endereco[0].Complemento != undefined">Complemento</label>
    <p *ngIf="dados.Endereco[0].Complemento != undefined">{{dados.Endereco[0].Complemento[0]}}</p>
    <label>Bairro</label>
    <p>{{dados.Endereco[0].Bairro[0]}}</p>
    <label>CEP</label>
    <p>{{dados.Endereco[0].CEP[0]}}</p>
    <label>Município</label>
    <p>{{dados.Endereco[0].NomeMunicipio[0]}}</p>
    <label>Código do Município</label>
    <p>{{dados.Endereco[0].CodigoMunicipio[0]}}</p>
    <label>UF</label>
    <p>{{dados.Endereco[0].UF[0]}}</p>
    <h5>Credenciamento</h5>
    <label>Tipo</label>
    <p>{{dados.Credenciamento[0].Tipo[0]}}</p>
    <label>Número</label>
    <p>{{dados.Credenciamento[0].Numero[0]}}</p>
    <label>Data</label>
    <p>{{dados.Credenciamento[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
    <label>Data de publicação</label>
    <p>{{dados.Credenciamento[0].DataPublicacao[0] | date: 'dd/MM/YYYY'}}</p>
    <label>Seção</label>
    <p>{{dados.Credenciamento[0].SecaoPublicacao[0]}}</p>
    <label>Página</label>
    <p>{{dados.Credenciamento[0].PaginaPublicacao[0]}}</p>
    <div *ngIf="dados.Recredenciamento != undefined">
      <h5>Recredenciamento</h5>
      <label>Recredenciado</label>
      <p>{{dados.Recredenciamento[0].Tipo[0]}}</p>
      <label>Número</label>
      <p>{{dados.Recredenciamento[0].Numero[0]}}</p>
      <label>Data</label>
      <p>{{dados.Recredenciamento[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{dados.Recredenciamento[0].SecaoPublicacao[0]}}</p>
      <label>Página</label>
      <p>{{dados.Recredenciamento[0].PaginaPublicacao[0]}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.Recredenciamento[0].DataPublicacao[0] | date: 'dd/MM/YYYY'}}</p>
    </div>

    <h5>Dados da Mantenedora</h5>
    <label>Razão Social</label>
    <p>{{dados.Mantenedora[0].RazaoSocial[0]}}</p>
    <label>CNPJ</label>
    <p>{{dados.Mantenedora[0].CNPJ[0]}}</p>
    <label *ngIf="dados.Mantenedora[0].Endereco[0].Logradouro != undefined">Logradouro</label>
    <p *ngIf="dados.Mantenedora[0].Endereco[0].Logradouro != undefined">{{dados.Mantenedora[0].Endereco[0].Logradouro[0]}}</p>
    <label *ngIf="dados.Mantenedora[0].Endereco[0].Numero != undefined">Numero</label>
    <p *ngIf="dados.Mantenedora[0].Endereco[0].Numero != undefined">{{dados.Mantenedora[0].Endereco[0].Numero[0]}}</p>
    <label *ngIf="dados.Mantenedora[0].Endereco[0].Complemento != undefined">Complemento</label>
    <p *ngIf="dados.Mantenedora[0].Endereco[0].Complemento != undefined">{{dados.Mantenedora[0].Endereco[0].Complemento[0]}}</p>
    <label>Bairro</label>
    <p>{{dados.Mantenedora[0].Endereco[0].Bairro[0]}}</p>
    <label>CEP</label>
    <p>{{dados.Mantenedora[0].Endereco[0].CEP[0]}}</p>
    <label>Município</label>
    <p>{{dados.Mantenedora[0].Endereco[0].NomeMunicipio[0]}}</p>
    <label>Código do Município</label>
    <p>{{dados.Mantenedora[0].Endereco[0].CodigoMunicipio[0]}}</p>
    <label>UF</label>
    <p>{{dados.Mantenedora[0].Endereco[0].UF[0]}}</p>
    <div *ngIf="dados.LivroRegistro != undefined">
      <h5>Livro Registro</h5>
      <label>Livro Registro</label>
      <p>{{dados.LivroRegistro.LivroRegistro[0]}}</p>
      <label>Número Folha do Diploma</label>
      <p>{{dados.LivroRegistro.NumeroFolhaDoDiploma[0]}}</p>
      <label>Número Sequência do Diploma</label>
      <p>{{dados.LivroRegistro.NumeroSequenciaDoDiploma[0]}}</p>
      <label>Processo do Diploma </label>
      <p>{{dados.LivroRegistro.ProcessoDoDiploma[0]}}</p>
      <label>Data Colação Grau</label>
      <p>{{dados.LivroRegistro.DataColacaoGrau[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Data de Expedição do Diploma</label>
      <p>{{dados.LivroRegistro.DataExpedicaoDiploma[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Data de Registro do Diploma</label>
      <p>{{dados.LivroRegistro.DataRegistroDiploma[0] | date: 'dd/MM/YYYY'}}</p>
    </div>

  </div>
</div>

<div *ngIf="tipo=='dados-curso'">
  <div class="body">
    <label>Nome do Curso</label>
    <p>{{dados.NomeCurso[0]}}</p>
    <label>Código Curso EMEC</label>
    <p>{{dados.CodigoCursoEMEC[0]}}</p>
    <label>Nome Habilitação</label>
    <p *ngIf="dados.NumeroHabilitacao">{{dados.NomeHabilitacao[0]}}</p>
    <label>Titulo Conferido</label>
    <p>{{dados.TituloConferido[0].OutroTitulo[0]}}</p>
    <label>Grau Conferido</label>
    <p>{{dados.GrauConferido[0]}}</p>
    <h5>Endereço do Curso</h5>
    <label *ngIf="dados.EnderecoCurso[0].Logradouro != undefined">Logradouro</label>
    <p *ngIf="dados.EnderecoCurso[0].Logradouro != undefined">{{dados.EnderecoCurso[0].Logradouro[0]}}</p>
    <label>Bairro</label>
    <p>{{dados.EnderecoCurso[0].Bairro[0]}}</p>
    <label>CEP</label>
    <p>{{dados.EnderecoCurso[0].CEP[0]}}</p>
    <label>Município</label>
    <p>{{dados.EnderecoCurso[0].NomeMunicipio[0]}}</p>
    <label>Código do Município</label>
    <p>{{dados.EnderecoCurso[0].CodigoMunicipio[0]}}</p>
    <label>UF</label>
    <p>{{dados.EnderecoCurso[0].UF[0]}}</p>

    <div *ngIf="dados.Autorizacao != undefined">
      <h5>Autorização</h5>
      <label>Tipo</label>
      <p>{{dados.Autorizacao[0].Tipo[0]}}</p>
      <label *ngIf="dados.Autorizacao[0].Numero != undefined">Número</label>
      <p *ngIf="dados.Autorizacao[0].Numero != undefined">{{dados.Autorizacao[0].Numero[0]}}</p>
      <label *ngIf="dados.Autorizacao[0].Complemento != undefined">Complemento</label>
      <p *ngIf="dados.Autorizacao[0].Complemento != undefined">{{dados.Autorizacao[0].Complemento[0]}}</p>
      <label>Data</label>
      <p>{{dados.Autorizacao[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
    </div>

    <div *ngIf="dados.Reconhecimento != undefined">
      <h5>Reconhecimento</h5>
      <label>Tipo</label>
      <p>{{dados.Reconhecimento[0].Tipo[0]}}</p>
      <label>Número</label>
      <p>{{dados.Reconhecimento[0].Numero[0]}}</p>
      <label>Data</label>
      <p>{{dados.Reconhecimento[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
    </div>

    <div *ngIf="dados.RenovacaoReconhecimento != undefined">
      <h5>Renovação Reconhecimento</h5>
      <label>Data</label>
      <p>{{dados.RenovacaoReconhecimento[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Número</label>
      <p>{{dados.RenovacaoReconhecimento[0].Numero[0]}}</p>
      <label>Tipo</label>
      <p>{{dados.RenovacaoReconhecimento[0].Tipo[0]}}</p>
    </div>

  </div>
</div>

<div *ngIf="tipo=='dados-ies'">
  <div class="body">
    <label>Nome</label>
    <p>{{dados.Nome[0]}}</p>
    <label>Código MEC</label>
    <p>{{dados.CodigoMEC[0]}}</p>
    <label>CNPJ</label>
    <p>{{dados.CNPJ[0]}}</p>
    <h5>Endereço do Curso</h5>
    <label *ngIf="dados.Endereco[0].Logradouro != undefined">Logradouro</label>
    <p *ngIf="dados.Endereco[0].Logradouro != undefined">{{dados.Endereco[0].Logradouro[0]}}</p>
    <label *ngIf="dados.Endereco[0].Numero != undefined">Número</label>
    <p *ngIf="dados.Endereco[0].Numero != undefined">{{dados.Endereco[0].Numero[0]}}</p>
    <label *ngIf="dados.Endereco[0].Complemento != undefined">Complemento</label>
    <p *ngIf="dados.Endereco[0].Complemento != undefined">{{dados.Endereco[0].Complemento[0]}}</p>
    <label>Bairro</label>
    <p>{{dados.Endereco[0].Bairro[0]}}</p>
    <label>CEP</label>
    <p>{{dados.Endereco[0].CEP[0]}}</p>
    <label>Município</label>
    <p>{{dados.Endereco[0].NomeMunicipio[0]}}</p>
    <label>Código do Município</label>
    <p>{{dados.Endereco[0].CodigoMunicipio[0]}}</p>
    <label>UF</label>
    <p>{{dados.Endereco[0].UF[0]}}</p>
    <h5>Credenciamento</h5>
    <label>Tipo</label>
    <p>{{dados.Credenciamento[0].Tipo[0]}}</p>
    <label>Número</label>
    <p>{{dados.Credenciamento[0].Numero[0]}}</p>
    <label>Data</label>
    <p>{{dados.Credenciamento[0].Data[0] | date: 'dd/MM/YYYY'}}</p>
    <label>Data de publicação</label>
    <p>{{dados.Credenciamento[0].DataPublicacao[0] | date: 'dd/MM/YYYY'}}</p>
    <label>Seção</label>
    <p>{{dados.Credenciamento[0].SecaoPublicacao[0]}}</p>
    <label>Página</label>
    <p>{{dados.Credenciamento[0].PaginaPublicacao[0]}}</p>
    <div *ngIf="dados.Recredenciamento">
      <h5>Recredenciamento</h5>
      <label>Recredenciado</label>
      <p>{{dados.Recredenciamento[0].Tipo[0]}}</p>
      <label>Número</label>
      <p>{{dados.Recredenciamento[0].Numero[0]}}</p>
      <label>Data</label>
      <p>{{dados.Recredenciamento[0].DataPublicacao[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{dados.Recredenciamento[0].SecaoPublicacao[0]}}</p>
      <label>Página</label>
      <p>{{dados.Recredenciamento[0].PaginaPublicacao[0]}}</p>
      <label>Data de Publicação</label>
      <p>{{dados.Recredenciamento[0].DataPublicacao[0] | date: 'dd/MM/YYYY'}}</p>
    </div>
    <div *ngIf="dados.Manetenedora != undefined">
      <h5>Dados da Mantenedora</h5>
      <label>Razão Social</label>
      <p>{{dados.Mantenedora[0].RazaoSocial[0]}}</p>
      <label>CNPJ</label>
      <p>{{dados.Mantenedora[0].CNPJ[0]}}</p>
      <label *ngIf="dados.Mantenedora[0].Endereco[0].Logradouro != undefined">Logradouro</label>
      <p *ngIf="dados.Mantenedora[0].Endereco[0].Logradouro != undefined">{{dados.Mantenedora[0].Endereco[0].Logradouro[0]}}</p>
      <label>Numero</label>
      <p>{{dados.Mantenedora[0].Endereco[0].Numero[0]}}</p>
      <label>Bairro</label>
      <p>{{dados.Mantenedora[0].Endereco[0].Bairro[0]}}</p>
      <label>CEP</label>
      <p>{{dados.Mantenedora[0].Endereco[0].CEP[0]}}</p>
      <label>Município</label>
      <p>{{dados.Mantenedora[0].Endereco[0].NomeMunicipio[0]}}</p>
      <label>Código do Município</label>
      <p>{{dados.Mantenedora[0].Endereco[0].CodigoMunicipio[0]}}</p>
      <label>UF</label>
      <p>{{dados.Mantenedora[0].Endereco[0].UF[0]}}</p>
    </div>

  </div>
</div>
